<h2 mat-dialog-title>Add new activity</h2>
  <form  [formGroup]="runForm">
    <mat-dialog-content>   
          <div class="row">
            <div class="col">Distance</div>
          </div>
          <div class="row">
                <div class="col-md-4">
                  <mat-form-field>
                    <input matInput [formControl]="form.distance" [errorStateMatcher]="matcher" type="number" id="distance" name="distance">
                  </mat-form-field>
                  <mat-error *ngIf="form.distance.hasError('required')">
                    <strong>required</strong>
                  </mat-error> 
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-select    [(value)]="metric">
                      <mat-option  *ngFor="let m of metrics" [value]="m.value" >
                        {{ m.value }}
                      </mat-option>                                                                                                                
                    </mat-select>
                  </mat-form-field>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
              </div>
          </div>

          <div class="row">
            <div class="col">Duration</div>
          </div>
            <div class="row">
              <div class="col">
                  <mat-form-field>
                    <mat-label>Hours</mat-label>
                    <input matInput [formControl]="form.h" type="number" class="form-control" name="h" maxlength="2"  id="h">
                  </mat-form-field>
                  <mat-error *ngIf="form.h.hasError('pattern')">
                    <strong>form is not good</strong>
                  </mat-error>
                  <mat-error *ngIf="form.h.hasError('required')">
                    <strong>required</strong>
                  </mat-error> 
              </div>

              <div class="col">
                <mat-form-field>
                  <mat-label>Minutes</mat-label>
                  <input matInput [formControl]="form.m" type="number"  class="form-control" name="m" maxlength="2" id="m">
                </mat-form-field>
                <mat-error *ngIf="form.m.hasError('pattern')">
                  <strong>form is not good</strong>
                </mat-error>
                <mat-error *ngIf="form.m.hasError('required')">
                  <strong>required</strong>
                </mat-error> 
                <mat-error *ngIf="form.m.hasError('max')">
                  <strong>Max is 60</strong>
                </mat-error> 
              </div>

            <div class="col">
              <mat-form-field>
                <mat-label>Sececonds</mat-label>
                <input matInput [formControl]="form.s" type="number"  class="form-control" name="s" maxlength="2"  id="s">
              </mat-form-field>
              <mat-error *ngIf="form.s.hasError('pattern')">
                <strong>form is not good</strong>
              </mat-error>
              <mat-error *ngIf="form.s.hasError('required')">
                <strong>required</strong>
              </mat-error> 
              <mat-error *ngIf="form.s.hasError('max')">
                <strong>Max is 60</strong>
              </mat-error> 
            </div>
          </div>
            

            <mat-form-field>
              <mat-label>Choose a date</mat-label>
              <input matInput [matDatepicker]="picker"
                type="text"
                placeholder="Date"
                [formControl]="form.dateActivity"
                name="dateActivity"
                id="dateActivity"
                class="form-control">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </mat-dialog-content>
          

            <mat-dialog-actions align="end">
              <div class="p-3">
                <button mat-button color="warn" *ngIf='formError'> Warning: Please check the form carefully for errors!</button>
                <button mat-button color="warn" *ngIf="paceMeterPerSecond < 0.8">The pace seems too slow? Please check form.</button>
                <button mat-button color="warn" *ngIf="paceMeterPerSecond > 5.8">The pace is to fast, are you Eliud Kipchoge? Please check form.</button>
              </div>
              <button mat-raised-button mat-dialog-close>Cancel</button>
              <button mat-raised-button (click)="saveRun()" color="primary">Save</button>
              <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
            </mat-dialog-actions>

  </form>


        
        